import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: ({ context, location }) => {
    // Admin routes require authenticated user
    // Actual admin check happens in the component via Convex query
    if (!context.userId) {
      throw redirect({
        to: '/sign-in',
        search: { redirect_url: location.href },
      })
    }
  },
  component: Outlet,
})
